import { type DBSchema, type IDBPDatabase, openDB } from "idb";
import type { StoredOutboxItem } from "./types";

export const OUTBOX_DB_NAME = "crm-pwa-outbox";
const OUTBOX_DB_VERSION = 2;
const STORE = "outbox";
const DRAFT_STORE = "drafts";
export const FIELD_LEAD_DRAFT_ID = "field-lead";

interface StoredDraft<T> {
  id: string;
  ownerKey: string;
  state: T;
  updatedAt: string;
}

interface OutboxDbSchema extends DBSchema {
  outbox: {
    key: string;
    value: StoredOutboxItem;
  };
  drafts: {
    key: string;
    value: StoredDraft<unknown>;
  };
}

export type OutboxDatabase = IDBPDatabase<OutboxDbSchema>;

export function openOutboxDb(): Promise<OutboxDatabase> {
  return openDB<OutboxDbSchema>(OUTBOX_DB_NAME, OUTBOX_DB_VERSION, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(STORE)) {
        db.createObjectStore(STORE, { keyPath: "id" });
      }
      if (!db.objectStoreNames.contains(DRAFT_STORE)) {
        db.createObjectStore(DRAFT_STORE, { keyPath: "id" });
      }
    },
  });
}

export function readAllItems(db: OutboxDatabase): Promise<StoredOutboxItem[]> {
  return db.getAll(STORE);
}

export async function writeItem(db: OutboxDatabase, item: StoredOutboxItem): Promise<void> {
  await db.put(STORE, item);
}

export async function removeItem(db: OutboxDatabase, id: string): Promise<void> {
  await db.delete(STORE, id);
}

export async function readDraft<T>(db: OutboxDatabase, id: string): Promise<StoredDraft<T> | null> {
  const stored = await db.get(DRAFT_STORE, id);
  return stored === undefined ? null : (stored as StoredDraft<T>);
}

export async function writeDraft<T>(db: OutboxDatabase, draft: StoredDraft<T>): Promise<void> {
  await db.put(DRAFT_STORE, draft);
}

export async function removeDraft(db: OutboxDatabase, id: string): Promise<void> {
  await db.delete(DRAFT_STORE, id);
}
